/**
 * @author      patrick@zumper.com (Patrick Giddings)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type { RentResearchDetail } from '@zcode/state-type'

export const RENT_RESEARCH_DETAIL_SLICE_NAME = 'rentResearchDetail'

export const RENT_RESEARCH_DETAIL_INITIAL_STATE: RentResearchDetail = {
  data: {
    costOfLivingCategories: null,
    discover: {
      affordable: null,
      deals: null,
      highestRated: null,
      luxury: null,
      petFriendly: null,
    },
    linkpacks: {
      address: null,
      building: null,
      afrCity: null,
      afrNeighborhood: null,
      hfrCity: null,
      hfrNeighborhood: null,
      rfrCity: null,
      rfrNeighborhood: null,
    },
    locationData: null,
    rentalData: null,
    renterOccupiedPercentage: null,
  },
  meta: {
    activeBedType: null,
    activePropertyType: null,
    currentKey: null,
    errorKey: null,
    fetchingKey: null,
  },
}
